import { userConstants } from "../constants/login.constants";

function toggleMFA(state = {
  loading: false,
}, action) {
  switch (action.type) {
    case userConstants.TOGGLEMFA_REQUEST:
      return {
        loading: true
      };
    case userConstants.TOGGLEMFA_SUCCESS:
      return {
        items: action.data,
        loading: false,
      };
    case userConstants.TOGGLEMFA_FAILURE:
      return {
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export default toggleMFA;